import Text from 'components/Text/Text';
import React, { useContext, useState, useEffect } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CancelAndSaveButtons.module.scss';

const CancelAndSaveButtons: React.FC = () => {
	const { changeTypeOfModalWindow, IDsSelectedCustomers, videos } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);
	const [isActiveSaveBtn, setIsActiveSaveBtn] = useState<boolean>(true);

	useEffect(() => {
		const someGameChanged = videos.some((el) => el.isChanged);
		setIsActiveSaveBtn(someGameChanged);
	}, [videos]);

	return (
		<div className={style.container} data-test="CancelAndSaveButtons">
			<Button
				className={style.cancelBtn}
				theme="outlined"
				onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				disabled={!Object.keys(IDsSelectedCustomers).length}
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				}>
				<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
			</Button>

			<Button
				className={style.saveBtn}
				theme="primaryBlue"
				onClick={() => changeTypeOfModalWindow('toConfirmSendChanges')}
				disabled={!isActiveSaveBtn}>
				<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
			</Button>
		</div>
	);
};

export default CancelAndSaveButtons;
